import { useState, useContext } from "react";
import { Form, Input, Select, Button, Upload, Card } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function RaiseTicket() {
    const [loading, setLoading] = useState(false);
    const { authData, backUrl } = useContext(AuthContext) || {};

    const [ticketData, setTicketData] = useState({
        subject: "",
        description: "",
        priority: "",
        ticket_type: "",
        attachment: null,
    });

    const [fileList, setFileList] = useState([]);

    const ticketTypes = ["PAYROLL", "LEAVE", "STATUTORY", "COMMON", "SYSTEM"];
    const priorityType = ["LOW", "MEDIUM", "HIGH", "URGENT"];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setTicketData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSelectChange = (name, value) => {
        setTicketData((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = ({ file, fileList }) => {
        setFileList(fileList);

        if (fileList.length > 0 && fileList[0].originFileObj) {
            setTicketData((prev) => ({
                ...prev,
                attachment: fileList[0].originFileObj,
            }));
        } else {
            setTicketData((prev) => ({
                ...prev,
                attachment: null,
            }));
        }
    };

    const handleSubmit = async () => {
        if (
            !ticketData.subject ||
            !ticketData.description ||
            !ticketData.priority ||
            !ticketData.ticket_type
        ) {
            toast.error("⚠️ Please fill all required fields.", { position: "top-center" });
            return;
        }

        const formData = new FormData();
        formData.append("subject", ticketData.subject);
        formData.append("description", ticketData.description);
        formData.append("priority", ticketData.priority);
        formData.append("ticket_type", ticketData.ticket_type);

        if (ticketData.attachment) {
            formData.append("attachment", ticketData.attachment);
        }

        try {
            setLoading(true);

            await axios.post(`${backUrl}/api/hr/tickets/`, formData, {
                headers: {
                    Authorization: authData ? `Bearer ${authData.access}` : undefined,
                    // ❌ DO NOT set Content-Type manually
                },
            });

            toast.success("Ticket raised successfully!", { position: "top-center" });

            // Reset everything
            setTicketData({
                subject: "",
                description: "",
                priority: "",
                ticket_type: "",
                attachment: null,
            });
            setFileList([]);

        } catch (error) {
            console.error(error);
            toast.error("Failed to raise ticket. Please try again.", { position: "top-center" });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <ToastContainer autoClose={3000} theme="colored" />

            <Card style={{ maxWidth: 600, margin: "20px auto", borderRadius: 10 }}>
                <Form layout="vertical" onFinish={handleSubmit}>

                    <Form.Item label="Subject" required>
                        <Input
                            name="subject"
                            value={ticketData.subject}
                            onChange={handleChange}
                            placeholder="Enter a short subject for your ticket"
                        />
                    </Form.Item>

                    <Form.Item label="Description" required>
                        <Input.TextArea
                            name="description"
                            rows={4}
                            value={ticketData.description}
                            onChange={handleChange}
                            placeholder="Describe your issue or request"
                        />
                    </Form.Item>

                    <Form.Item label="Ticket Type" required>
                        <Select
                            placeholder="Select Ticket Type"
                            value={ticketData.ticket_type || undefined}
                            onChange={(value) => handleSelectChange("ticket_type", value)}
                        >
                            {ticketTypes.map((type) => (
                                <Select.Option key={type} value={type}>
                                    {type}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item label="Priority" required>
                        <Select
                            placeholder="Select Priority"
                            value={ticketData.priority || undefined}
                            onChange={(value) => handleSelectChange("priority", value)}
                        >
                            {priorityType.map((p) => (
                                <Select.Option key={p} value={p}>
                                    {p}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item label="Attachment (optional)">
                        <Upload
                            beforeUpload={() => false}
                            fileList={fileList}
                            onChange={handleFileChange}
                            maxCount={1}
                        >
                            <Button icon={<UploadOutlined />}>Click to Upload</Button>
                        </Upload>
                    </Form.Item>

                    <center>
                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={loading}
                                block
                                style={{
                                    borderRadius: 8,
                                    backgroundColor: "#0e497b",
                                    width: "50%",
                                }}
                            >
                                Submit Ticket
                            </Button>
                        </Form.Item>
                    </center>

                </Form>
            </Card>
        </>
    );
}
